import { withNamespaces } from "react-i18next";
import ReactApexChart from "react-apexcharts";
import { Card, CardBody, CardTitle } from "reactstrap";

const RISK_GROUPS = [
    { key: "totalRisks", label: "Total Risks" },
    { key: "mitigatedRisks", label: "Mitigated Risks" },
    { key: "acceptedRisks", label: "Accepted Risks" }
];

const toCount = (value) => Number(value || 0);

const RisksCreatedChart = ({ t, risk = {} }) => {
    const statistics = risk.statistics || {};
    const chartData = {
        series: [
            {
                name: t("Total"),
                data: RISK_GROUPS.map((group) =>
                    toCount(statistics[group.key]?.total)
                )
            },
            {
                name: t("Mine"),
                data: RISK_GROUPS.map((group) =>
                    toCount(statistics[group.key]?.mine)
                )
            }
        ],
        options: {
            chart: {
                toolbar: { show: false }
            },
            noData: {
                text: t("There is no data")
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: "55%",
                    endingShape: "rounded"
                }
            },
            dataLabels: { enabled: false },
            stroke: {
                show: true,
                width: 2,
                colors: ["transparent"]
            },
            colors: ["#5B3E62", "#78E09B"],
            xaxis: {
                categories: RISK_GROUPS.map((group) => t(group.label))
            },
            yaxis: {
                min: 0,
                forceNiceScale: true,
                labels: {
                    formatter: (val) => `${Math.round(Number(val) || 0)}`
                }
            },
            legend: {
                show: true,
                position: "bottom",
                horizontalAlign: "left"
            },
            grid: { borderColor: "#f1f1f1" },
            fill: { opacity: 1 }
        }
    };

    return (
        <Card className="overview-sustainability-card h-100 mb-0">
            <CardBody>
                <CardTitle className="overview-section-title mb-3">
                    {t("The Number of Mitigated and Accepted Risks Created")}
                </CardTitle>
                <ReactApexChart
                    options={chartData.options}
                    series={chartData.series}
                    type="bar"
                    height={300}
                />
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(RisksCreatedChart);
